import { Theme } from '@mui/material';

export default {
  components: {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        width: '97%',
        margin: 'auto',
        borderRadius: '6px',
        backgroundColor: theme.palette.secondary.main,
        '&.Mui-selected': {
          backgroundColor: theme.palette.secondary.main
        },
        '&.Mui-selected:hover': {
          backgroundColor: theme.palette.secondary.main
        }
      })
    }
  }
};
